<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Font Pairing</h1>
                <v-btn to="/font-pairing/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Font Pairing
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="11"
                align="center"
                justify="center"
            >
                <FontPairingEditForm />
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>Delete Font Pairing: {{ name }}
                </v-card-title>
                <v-card-text>
                    <p>Deleting this font pairing is permanent and cannot be undone.</p>
                    <p>Click "DELETE FONT PAIRING" to proceed.</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Font Pairing
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import FontPairingEditForm from './FontPairingEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { Overlay, FontPairingEditForm },


    computed: {
        ...mapState('fontPairingEditor', ['deleteModal', 'name']),
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'fontPairingEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            getData: 'fontPairingEditor/getData',
            saveData: 'fontPairingEditor/saveData',
            destroyData: 'fontPairingEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
